import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { activarSincronizacionAutomatica } from './app/infrastructure/offline/sincronizador';
import { pedirStoragePersistente } from './app/infrastructure/offline/almacenamiento';
import { limpiarBlobsSincronizadosAntiguos } from './app/infrastructure/offline/db';
import { precargarRegresoDeMicrosoft } from './app/infrastructure/entra/cliente';

activarSincronizacionAutomatica();
void pedirStoragePersistente();
// Tambien al arrancar (no solo tras sincronizar): cubre el caso de un
// dispositivo que abre offline y no dispara ninguna sincronizacion nueva,
// pero igual tiene fotos viejas ya sincronizadas ocupando espacio.
void limpiarBlobsSincronizadosAntiguos();

// A PROPOSITO antes de bootstrapApplication(): MSAL necesita leer el
// "#code=..." que Microsoft deja en la URL al volver de loginRedirect, pero
// el Router de Angular limpia/normaliza esa URL como parte de su propia
// navegacion inicial. Si dejamos que MSAL lo lea recien despues de que la
// app (Router incluido) ya arranco, es una carrera que se puede perder — el
// login se "pierde" en silencio, sin ningun error, porque tecnicamente nada
// fallo. No hace nada (ni red) si no hay un regreso de Microsoft pendiente.
//
// Limite de 15s a proposito: esto SOLO se activa en el instante puntual de
// volver de loguearse con Microsoft (uso normal del dia a dia, sin login de
// por medio, no toca esto para nada). Si justo en ese instante la señal se
// corta, preferimos arrancar la app igual (con su pantalla de carga y aviso
// normal) a dejarla en blanco para siempre esperando a MSAL — la operacion
// de MSAL no se cancela, sigue sola en segundo plano y auth.service.ts la
// recoge mas tarde si termina llegando.
const ESPERA_MAXIMA_REGRESO_MICROSOFT_MS = 15000
void Promise.race([
  precargarRegresoDeMicrosoft(),
  new Promise((resolve) => setTimeout(resolve, ESPERA_MAXIMA_REGRESO_MICROSOFT_MS)),
]).finally(() => {
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
});
